<template>
  <div class="content "
       :class="{'loading-overlay loading-overlay-progress': donationsState !== 'ready'}">

    <reports-menu
        :start-date="startDate"
        :end-date="endDate"
        v-on:update-date="updateDate"
        :first-donation-date="firstDonationDate"
        v-on:download="download"
        :isSearchBox="true"
        v-model="searchDonorsName"
    ></reports-menu>

    <div class="flex flex-wrap overflow-hidden px-8 md:px-4 pt-4 d-reports tab-donations">

      <div class="w-4/5 xl:w-4/6 md:w-full pr-5 md:pr-0">
        <div class="d-block shadow-md rounded-md bg-white">
          <h3 class="title">
            <div class=" flex flex-wrap -mx-2">
              <div class="px-2 w-1/2">Donations</div>
              <div class="px-2 w-1/2 text-right "><span>{{ selected(startDate, endDate) | intervalLabel }}</span></div>
            </div>
          </h3>
          <div class="contacts-list campaign-donations-list">
            <div id="c-donations-table_wrapper">
              <el-table
                  style = "width: 100%"
                  :default-sort = "sorting"
                  :data = "itemsDataPage"
                  :height = "tableHeight + 110"
                  v-on:sort-change="sortChange"
              >
                <template slot="empty">
                  <div class="empty-placeholder">
                    <img :src="require('../../assets/paceholders/30.svg')" alt="No results">
                    <h3>No Donations in this Timeframe</h3>
                  </div>
                </template>
                <el-table-column label="Date"
                                 prop="created_at"
                                 :sort-orders="['descending', 'ascending']"
                                 sortable="custom"
                                 width="150"
                >
                  <template slot-scope="scope">
                    {{ scope.row.created_at | dateFormat('MMM DD, YYYY') }}
                    <div class="info">{{ scope.row.created_at | dateFormat('h:mma') }}</div>
                  </template>
                </el-table-column>

                <el-table-column label="Name & Email"
                                 prop="_full_name"
                                 sortable="custom"
                                 :sort-orders="['ascending', 'descending']"
                                 min-width="300"
                >
                  <template slot-scope="scope">
                    <div class="donor">
                      <span v-if="scope.row.is_guest">{{ scope.row.first_name }} {{ scope.row.last_name }}</span>
                      <span v-else class="show-donor-info"
                            v-on:click.prevent="showDonorSidebar(scope.row.uid)"
                      >{{ scope.row.first_name }} {{ scope.row.last_name }}</span>
                      <div class="info" :set="donorEmail = getDeletedDonorEmail(scope.row.email)">
                        {{donorEmail[1]}} <span class="danger" v-if="donorEmail[0]">(deleted)</span>
                      </div>
                    </div>
                  </template>
                </el-table-column>

                <el-table-column label="Type"
                                 prop="type"
                                 sortable="custom"
                                 :sort-orders="['ascending', 'descending']"
                                 min-width="140"
                >
                  <template slot-scope="scope">
                    <span :class="{
                      'txt-orange': scope.row.type === 'custom',
                      'txt-green': scope.row.type === 'recurring',
                      'txt-blue': (scope.row.type !== 'recurring' && scope.row.type !== 'custom')
                    }">{{ getDonationTypeTitle(scope.row.type) }}</span>
                    <div class="info">Type</div>
                  </template>
                </el-table-column>

                <el-table-column label="Intended"
                                 prop="intended_amount"
                                 sortable="custom"
                                 :sort-orders="['descending', 'ascending']"
                                 min-width="140"
                >
                  <template slot-scope="scope">
                    <span>${{ scope.row.intended_amount / 100 | formatMoney(0, 9) }}</span>
                    <div class="info">Amount</div>
                  </template>
                </el-table-column>

                <el-table-column label="Fees Covered"
                                 prop="covered_fee"
                                 sortable="custom"
                                 :sort-orders="['descending', 'ascending']"
                                 min-width="140"
                >
                  <template slot-scope="scope">
                    <span v-if="scope.row.covered_fee" class="txt-green">
                      ${{ scope.row.covered_fee / 100 | formatMoney(0, 9) }}
                    </span>
                    <span v-else>--</span>
                    <div class="info">Fees</div>
                  </template>
                </el-table-column>

                <el-table-column label="Donation"
                                 prop="amount"
                                 sortable="custom"
                                 :sort-orders="['descending', 'ascending']"
                                 min-width="140"
                >
                  <template slot-scope="scope">
                    <span content="Click to download receipt"
                          v-tippy
                          style="cursor: pointer; outline: none;"
                          v-on:click="$refs.receipt.generatePdf(scope.row, activeCharityInfo);">
                    <span
                        class="txt-dark-blue">${{ scope.row.amount / 100 | formatMoney(0, 9) }}</span><br>
                    <span class="info">Donation</span>
                    </span>
                  </template>
                </el-table-column>

                <el-table-column label=""
                                 width="75"
                >
                  <template slot-scope="scope">

                    <el-dropdown trigger="click"
                                 @command="handleCommand"
                    >
                      <span class="el-dropdown-link inline-block text-gray-500 text-xl rounded-full h-8 w-8 flex items-center justify-center hover:bg-gray-200">
                        <font-awesome-icon :icon="['far', 'ellipsis-v']"  />
                      </span>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item :command="['edit', scope.row]">Edit Donation</el-dropdown-item>
                        <el-dropdown-item :command="['refund', scope.row]">Refund Donation</el-dropdown-item>
                        <el-dropdown-item :command="['download', scope.row]">Download Receipt</el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>

                  </template>
                </el-table-column>

              </el-table>
              <el-pagination
                  class="text-right"
                  background
                  :current-page.sync="currentPage"
                  layout="prev, pager, next"
                  :page-size="paginationInfo.pageSize"
                  :total="itemsData.length">
              </el-pagination>
            </div>
          </div>
        </div>
      </div>

      <div class="w-1/5 xl:w-2/6 md:w-full">
        <div class="d-block d-block-overview summary shadow-md rounded-md bg-white px-6 py-4">
          <h2>Summary</h2>
          <div class="welcome">{{ selected(startDate, endDate) | intervalLabel }}</div>
          <div class="total">
            <span class="text-3xl">${{ (summary.custom + summary.rounds + summary.monthly) / 100 | formatMoney }}</span>
            <span v-if="diffPercent"
                  class="percent-diff"
                  :class="{'negative': diffPercent<0}"
            >{{ diffPercent > 0 ? '+' : '' }}{{ diffPercent }}%</span>
          </div>
          <div class="welcome">Donation Breakdown</div>
          <table class="table">
            <tbody>
            <tr>
              <td>One-Time</td>
              <td class="value txt-orange">${{ summary.custom / 100 | formatMoney }}</td>
            </tr>
            <tr>
              <td>Monthly</td>
              <td class="value txt-green">${{ summary.monthly / 100 | formatMoney }}</td>
            </tr>
            <tr>
              <td>Round-Ups</td>
              <td class="value txt-blue">${{ summary.rounds / 100 | formatMoney }}</td>
            </tr>
            <tr>
              <td>Total Donations</td>
              <td class="value">${{ (summary.custom + summary.rounds + summary.monthly) / 100 | formatMoney }}</td>
            </tr>
            </tbody>
          </table>
          <div class="welcome">Fees & Totals</div>
          <table class="table">
            <tbody>
            <tr>
              <td>Donation Amounts</td>
              <td class="value">${{ summary.total_amounts / 100 | formatMoney }}</td>
            </tr>
            <tr>
              <td>Fees Covered</td>
              <td class="value txt-green"
              >${{ summary.fees_covered / 100 | formatMoney }}
              </td>
            </tr>
            <tr>
              <td>Total Donations</td>
              <td class="value txt-blue"
              >${{ (summary.total_amounts + summary.fees_covered) / 100 | formatMoney }}
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>

    </div>

    <donor-info v-if="showDonorInfo"
                :donor-id="showDonorId"
                v-on:close-info="showDonorInfo = false"
    ></donor-info>

    <modal v-if="refundModal"
           v-on:close-modal="refundModal = false;"
           class="list-modal-wrap"
           :modal-name="'message-turn-off'">

      <div slot="header">
        <div class="info">Refund Donation</div>
      </div>
      <div slot="body" class="desc">
        <div class="input-control form-item">
          <h5 class="name" style="margin:5px 0;">${{ selectedDonation.amount / 100 | formatMoney(2) }}
            Donation by {{ selectedDonation.first_name }} {{ selectedDonation.last_name }}</h5>
          <label>Refunds take 5-10 days to appear on a donor's statement.
          </label>
        </div>

        <div class="input-control">
          <label for="d-method">Reason:</label>
          <select
              id="d-method"
              class="form-control"
              v-model="refundInfo.reason"
          >
            <option value="duplicate">Duplicate</option>
            <option value="fraudulent">Fraudulent</option>
            <option selected value="requested_by_customer">Requested by Donor</option>
          </select>
          <small v-if="refundInfo.reason === 'fraudulent'" class="txt-red"
          >Are you sure this was "fraudulent"? Selecting this option will add the associated card
            to a block list and will no longer be a valid payment source</small>
        </div>


        <div class="input-control">
          <label for="refund-text">Note:</label>
          <textarea class="input-sm list-add-text "
                    id="refund-text"
                    style="height: auto"
                    v-model="refundInfo.note"
                    maxlength="500"
                    rows="3"
                    placeholder="Add more details about this refund"></textarea>
        </div>

      </div>
      <template slot="footer">
        <div>
          <a v-on:click.prevent="refundModal = false"
             href="#" class="cancel">Cancel</a>
        </div>
        <div>
          <button type="submit"
                  v-on:click.prevent="refundDonation(selectedDonation);refundModal = false; "
                  class="btn btn-sm btn-delete btn-add-to-message"
          >Refund Donation
          </button>
        </div>
      </template>
    </modal>

    <modal v-if="editModal"
           v-on:close-modal="editModal = false;"
           class="list-modal-wrap"
           :modal-name="'message-turn-off'">

      <div slot="header">
        <div class="info">Edit Donation</div>
      </div>
      <div slot="body" class="desc">
        <div class="input-control form-item">
          <label>Full Name</label>
          <div class="name"><b>{{ selectedDonation.first_name }} {{ selectedDonation.last_name }}</b></div>
        </div>

        <div class="input-control form-item">
          <label>Amount</label>
          <div class="name"><b>${{ selectedDonation.amount / 100 | formatMoney }}</b></div>
        </div>

        <div v-if="allCampaigns && allCampaigns.length>0" class="input-control">
          <label for="edit-cmp">Campaign</label>
          <select
              id="edit-cmp"
              class="form-control"
              v-model="editParams.campaign_id"
          >
            <option :value="null">Area of Greatest Need</option>
            <option v-for="campaign in allCampaigns"
                    :key="campaign.id"
                    :value="campaign.id">{{ campaign.name }}
            </option>
          </select>
        </div>

        <div class="input-control">
          <span v-if="editParams.public" class="limit">Public</span>
          <span v-else class="limit limit-red">Private</span>
          <label for="note-text">Note/Comment</label>
          <textarea class="input-sm list-add-text "
                    id="note-text"
                    style="height: auto"
                    v-model="editParams.message"
                    rows="3"
                    placeholder="Note/Comment"></textarea>
        </div>

        <label class="form-switch">
          <input
              type="checkbox"
              v-model="editParams.public"
          > Display this note Publicly
        </label>

      </div>
      <template slot="footer">
        <div>
          <a v-on:click.prevent="editModal = false"
             href="#" class="cancel">Cancel</a>
        </div>
        <div>
          <button type="submit"
                  v-on:click.prevent="editDonation(selectedDonation);editModal = false; "
                  class="btn btn-sm btn-add-to-message"
          >Save Changes
          </button>
        </div>
      </template>
    </modal>

    <receipt ref="receipt"></receipt>
  </div>
</template>

<script>
import {formatMoney} from '@/utils/utils';
import ReportsMenu from './menu.vue';
import DonorInfo from '../Parts/DonorInfo.vue';
import reportsMixin from './reports-mixin';
import reportsMenuMixin from './reports-menu-mixin';
import dataTableMixin from '../Parts/data-table-mixin';
import Receipt from '../Receipt';
import Modal from '../Modal/index.vue';
import {mapActions, mapState} from 'vuex';
import {customFields} from "@/utils/api";

const moment = require('moment');

export default {
  name: 'Reports',
  mixins: [reportsMixin, reportsMenuMixin, dataTableMixin],
  components: {
    ReportsMenu,
    DonorInfo,
    Receipt,
    Modal
  },
  metaInfo: {
    title: 'Reports - Donations',
  },
  created() {
    this.sorting = {prop: 'created_at', order: 'descending'};
  },
  mounted() {
    this.updateCampaigns({charity_id: this.activeCharityId});
  },
  methods: {
    sortChange(sorting) {
      this.sorting = sorting
    },
    handleCommand([command, payload]) {
      switch (command){
        case 'edit':
          this.openEditModal(payload)
          break
        case 'refund':
          this.selectedDonation = payload;
          this.refundModal = true;
          break
        case 'download':
          this.$refs.receipt.generatePdf(payload, this.activeCharityInfo);
          break
      }
    },
    openEditModal(donationInfo) {

      this.selectedDonation = donationInfo;
      this.editParams.campaign_id = donationInfo.campaign_id;
      this.editParams.message = donationInfo.note;
      this.editParams.public = donationInfo.is_note_public;

      this.editModal = true;
    },
    editDonation(donationInfo) {
      let editParams = {
        "campaign_id": this.editParams.campaign_id
      };
      if (this.editParams.message) {
        editParams['note'] = {
          "message": this.editParams.message,
          "public": this.editParams.public
        };
      } else {
        editParams['note'] = null;
      }


      this.$store.dispatch('donations/editDonationNode', {
        charityId: this.activeCharityId,
        donationId: donationInfo.id,
        params: editParams
      })
          .then(() => this.$message('Donation updated'))
          .catch(err => alert(err));
    },
    ...mapActions('campaigns', [
      'updateCampaigns',
    ]),
    refundDonation(selectedDonation) {
      this.$store.dispatch('donations/refundDonation', {
        charityId: this.activeCharityId,
        donationId: selectedDonation.id,
        params: this.refundInfo
      })
          .then(() => this.$message('Donation refunded'))
          .catch(err => alert(err));
    },
    async download(type) {

      const title = `Donation Reports ${this.period.start.format('MMM D YYYY')} - ${this.period.end.format(
          'MMM D YYYY')}`;

      let header = [
        'Date', 'Time',
        ...(type === 'csv' ? ['First Name', 'Last Name'] : ['Name']),
        'Email',
        'Donation Type',
        ...(type === 'csv' ? [
          'Campaign',
          'Honoree',
          'From Name',
          'Honor OR Memory',
          'In Honor/Memory Message',
          'Method of Delivery',
          'Honoree Email',
          'Honoree Address'
        ] : []),
        'Intended Amount',
        ...(type === 'csv' ? ['Donation Note'] : []),
        'Fees Covered',
        ...(type === 'csv' ? ['Harness Fee', 'Stripe Fee'] : []),
        'Total Donation',
        ...(type === 'csv' ? [
          'Phone Number',
          'Street Address 1',
          'Street Address 2',
          'City',
          'State',
          'Zip Code',
          'Country',
        ] : []),
      ];


      let custom_fields = {};
      //add custom fields for CSV
      if (type === 'csv') {

        custom_fields = await customFields.getAll(this.activeCharityId);

        custom_fields = custom_fields
            .filter(f => !f.archived)
            .reduce((res, f) => {
              res[f.id] = f.properties.name;
              return res;
            }, {})

        if (Object.values(custom_fields).length) {
          header = [...header, ...Object.values(custom_fields)];
        }
      }

      const body = this.itemsDataSorted.map(item => {

        const dt = moment(item.created_at);
        return [
          dt.format('MMM D, YYYY'),
          dt.format('h:mma'),
          ...(type === 'csv' ? [item.first_name, item.last_name] : [item.first_name + ' ' + item.last_name]),
          item.email,
          this.getDonationTypeTitle(item.type),
          ...(type === 'csv' ? [
            item.campaign || '',
            item.metadata && item.metadata.honor && item.metadata.honor.name || '',
            item.metadata && item.metadata.honor && item.metadata.honor.from || '',
            item.metadata && item.metadata.honor && item.metadata.honor.type || '',
            item.metadata && item.metadata.honor && item.metadata.honor.message || '',
            item.metadata && item.metadata.honor && item.metadata.honor.method || 'none',
            item.metadata && item.metadata.honor && item.metadata.honor.email || '',
            item.metadata && item.metadata.honor && item.metadata.honor.address || '',
          ] : []),
          '$' + formatMoney(item.intended_amount / 100, 2, 9),
          ...(type === 'csv' ? [item.note || ''] : []),

          '$' + formatMoney(item.covered_fee / 100, 2, 9),

          ...(type === 'csv' ? [
            '$' + formatMoney(item.platform_fee / 100, 2, 9),
            '$' + formatMoney((item.stripe_fee - item.platform_fee) / 100, 2, 9),
          ] : []),

          '$' + formatMoney(item.amount / 100, 2, 9),
          ...(type === 'csv' ? [
            item.phone && item.phone.phone_number || '',
            item.address ? `${item.address.street_number} ${item.address.route}` : '',
            item.address && item.address.premise || '',
            item.address && item.address.locality || '',
            item.address && item.address.administrative_area_level_1 || '',
            item.address && item.address.postal_code || '',
            item.address && item.address.country || '',
          ] : []),

          ...(Object.values(custom_fields).length ? [
                ...Object.keys(custom_fields).map(cIndex => {

                  if (item.custom_fields
                      && Object.values(item.custom_fields)
                      && Object.values(item.custom_fields).length
                  ) {

                    const tmp = Object.values(item.custom_fields).find(c => c.field_id == cIndex);
                    if (tmp) {
                      return tmp['value'];
                    }
                  }
                  return '';
                })
              ] : []
          )

        ];
      });

      this.exportData(type, title, header, body, {
        0: {minCellWidth: 25},
        1: {minCellWidth: 20},
      });
    },
    getDeletedDonorEmail: (value) => {
      const index = value.indexOf(' ');
      if(index!== -1) {
        return [true, value.slice(0, index)]
      }

      return [false, value];
    }
  },
  computed: {
    ...mapState({
      allCampaigns: state => state.campaigns.allCampaigns,
      donations: state => state.donations.donations,
      donationsState: state => state.donations.donationsState,
      activeCharityId: state => state.auth.activeCharityId,
      activeCharityInfo: state => state.charities.activeCharityInfo,
    }),
    itemsData() {

      let donationsData = this.donationsData.map(d => ({
        ...d,
        intended_amount: Number(d.covered_fee) > 0 ? d.amount - Number(d.covered_fee) : d.amount,
        covered_fee: Number(d.covered_fee)
      }));

      if (this.searchDonorsName) {
        const re = new RegExp(this.searchDonorsName, 'ig');

        donationsData = donationsData.filter(d => `${d.first_name} ${d.last_name}`.search(re) !== -1);
      }

      return this.donationsFillCampaigns(donationsData, this.allCampaigns);
    },
  },
  watch: {
    'activeCharityId'() {
      this.updateCampaigns({charity_id: this.activeCharityId});
    },
    'refundModal'() {
      if (!this.refundModal) {
        this.refundInfo = {reason: 'requested_by_customer', note: ''}
      }
    }
  },
  data() {
    return {
      showDonorInfo: false,
      showDonorId: null,
      searchDonorsName: '',

      selectedDonation: null,
      refundModal: false,
      refundInfo: {
        reason: 'requested_by_customer', //'duplicate', 'fraudulent', 'requested_by_customer'
        note: '',
      },

      editModal: false,

      editParams: {
        campaign_id: null,
        message: '',
        public: false
      },
    };
  },
};
</script>
